import {SagaIterator} from "redux-saga";
import {all, takeLatest} from "redux-saga/effects";
import {
	fetchFanSentimentsJson,
	fetchPredictions,
	fetchPredictionSimulate,
	fetchSettingsJSON,
	fetchSquadsJson,
	fetchSupportedCountriesJson,
	saveFanSentiments,
	savePredictions,
	fetchFanFactsJSON,
	fetchQualifierGroupsJSON,
	fetchQualifierSquadsJSON,
	fetchPredictionSimulateLite,
} from "apps/DRAW_PREDICTOR/modules/actions";
import {
	fetchSquadsJSONSaga,
	fetchPredictionSimulateSaga,
	fetchSupportedCountriesJSONSaga,
	fetchFanSentimentsJSONSaga,
	saveFanSentimentsSaga,
	fetchSettingsJSONSaga,
	fetchPredictionsSaga,
	savePredictionsSaga,
	fetchFanFactsJSONSaga,
	fetchQualifierGroupsJSONSaga,
	fetchQualifierSquadsJSONSaga,
	fetchPredictionSimulateLiteSaga,
} from "apps/DRAW_PREDICTOR/modules/sagas";

export const projectSaga = function* (): SagaIterator {
	yield all([
		/**
		 * JSON's
		 */
		takeLatest(fetchSquadsJson, fetchSquadsJSONSaga),
		takeLatest(fetchSupportedCountriesJson, fetchSupportedCountriesJSONSaga),
		takeLatest(fetchFanSentimentsJson, fetchFanSentimentsJSONSaga),
		takeLatest(fetchSettingsJSON, fetchSettingsJSONSaga),
		takeLatest(fetchFanFactsJSON, fetchFanFactsJSONSaga),
		takeLatest(fetchQualifierGroupsJSON, fetchQualifierGroupsJSONSaga),
		takeLatest(fetchQualifierSquadsJSON, fetchQualifierSquadsJSONSaga),

		/**
		 * Predictions
		 */
		takeLatest(fetchPredictionSimulate, fetchPredictionSimulateSaga),
		takeLatest(fetchPredictionSimulateLite, fetchPredictionSimulateLiteSaga),

		takeLatest(fetchPredictions, fetchPredictionsSaga),
		takeLatest(savePredictions, savePredictionsSaga),

		/**
		 * Fan Sentiments
		 */
		takeLatest(saveFanSentiments, saveFanSentimentsSaga),
	]);
};

export * from "./projectJsons";
export * from "./predictions";
export * from "./fanSentiments";
